// import { qs, toggleElement } from './utils/dom'
import Header from "./layout/header";

window.addEventListener('load', () => {
    hashInit();
    Header.init();
});

window.addEventListener('resize', () => {
});

function scrollTo(target) {
    const menuButton = document.querySelector('header.header .nav-burger');
    const menu = document.querySelector('header.header .nav-main');

    const header = document.querySelector('header.header');
    const headerHeight = header ? header.offsetHeight : 120;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = Math.max(0, targetPosition - headerHeight);

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
    });

    menu?.classList.remove('is-open');
    if (menuButton) menuButton.innerHTML = menuButton.dataset.toggleClosed;
}

function hashInit() {
    if (!window.location.hash) return;

    const hash = window.location.hash;
    const id = hash.substring(1);
    let target = document.getElementById(id);

    if (!target) {
        try {
            target = document.querySelector(hash);
        } catch (e) {
            console.log('Invalid selector:', e);
            target = null;
        }
    }

    if (target) {
        // small delay to ensure layout/calculated heights are ready
        setTimeout(() => {
            scrollTo(target);
        }, 200);
    }
}